import type { SelectChangeEvent } from "@mui/material";
import { CustomIntervalType as CustomIntervalTypeEnum } from "@sinch/core/entities/serverEnums";
import { CustomIntervalType } from "@sinch/types/sinch.types";
import { FC, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useCustomIntervalType } from "@sinch/components/application/Rate/useIntervalType";
import { SelectInput } from "@sinch/components/form/SelectInput/SelectInput";
import { useMuiController } from "@sinch/components/index";

export const CreateIntervalTypeField: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const {
    field: { onChange, ...field },
  } = useMuiController({ name: "type" });
  const { setValue } = useFormContext();
  const { getOptionsList, getCustomIntervalSchema } = useCustomIntervalType();
  const handleChange = useCallback(
    (event: SelectChangeEvent<CustomIntervalType | CustomIntervalTypeEnum>) => {
      setValue("settings", getCustomIntervalSchema(event.target.value as CustomIntervalType).getDefault());
      onChange(event);
    },
    [onChange, setValue]
  );

  return (
    <SelectInput
      onChange={handleChange}
      {...field}
      disabled={disabled}
      disablePortal
      fullWidth
      label={t("RateUnit.intervalType")}
      options={getOptionsList()}
    />
  );
};
